export { default } from 'shared/components/tabs'
